import { Diagnostic } from "@siteimprove/alfa-act";
import { Comparison } from "@siteimprove/alfa-comparable";
/**
 * @public
 */
export class Contrast extends Diagnostic {
    static of(message, threshold = 4.5, pairings = []) {
        return new Contrast(message, threshold, Array.from(pairings));
    }
    _threshold;
    _pairings;
    constructor(message, threshold, pairings) {
        super(message);
        this._threshold = threshold;
        this._pairings = pairings;
    }
    get threshold() {
        return this._threshold;
    }
    get pairings() {
        return this._pairings;
    }
    equals(value) {
        return (super.equals(value) &&
            value instanceof Contrast &&
            value._threshold === this._threshold &&
            value._pairings.length === this._pairings.length &&
            value._pairings.every((pairing, i) => pairing.equals(this._pairings[i])));
    }
    hash(hash) {
        super.hash(hash);
        hash.writeNumber(this._threshold);
        // We don't hash the pairings as it may take too long.
    }
    toJSON(options) {
        return {
            ...super.toJSON(options),
            threshold: this._threshold,
            pairings: this._pairings.map((pairing) => pairing.toJSON()),
        };
    }
}
/**
 * @public
 */
(function (Contrast) {
    function isContrast(value) {
        return value instanceof Contrast;
    }
    Contrast.isContrast = isContrast;
    class Pairing {
        static of(color1, color2, contrast) {
            return new Pairing(Color.of(...color1), Color.of(...color2), contrast);
        }
        _color1;
        _color2;
        _contrast;
        constructor(color1, color2, contrast) {
            this._color1 = color1;
            this._color2 = color2;
            this._contrast = contrast;
        }
        hash(hash) {
            hash
                .writeHashable(this._color1)
                .writeHashable(this._color2)
                .writeNumber(this._contrast);
        }
        get color1() {
            return this._color1;
        }
        get color2() {
            return this._color2;
        }
        get contrast() {
            return this._contrast;
        }
        equals(value) {
            return (value instanceof Pairing &&
                value._color1.equals(this._color1) &&
                value._color2.equals(this._color2) &&
                value._contrast === this._contrast);
        }
        compare(value) {
            if (this._contrast < value.contrast) {
                return Comparison.Greater;
            }
            if (this._contrast > value.contrast) {
                return Comparison.Less;
            }
            return Comparison.Equal;
        }
        toJSON() {
            return {
                color1: this._color1.toJSON(),
                color2: this._color2.toJSON(),
                contrast: this._contrast,
            };
        }
    }
    Contrast.Pairing = Pairing;
    class Color {
        static of(name, value) {
            return new Color(name, value);
        }
        _name;
        _value;
        constructor(name, value) {
            this._name = name;
            this._value = value;
        }
        hash(hash) {
            hash.writeString(this._name).writeHashable(this._value);
        }
        get name() {
            return this._name;
        }
        get value() {
            return this._value;
        }
        equals(value) {
            return (value instanceof Color &&
                value._name === this._name &&
                value._value.equals(this._value));
        }
        toJSON() {
            return {
                name: this._name,
                value: this._value.toJSON(),
            };
        }
    }
})(Contrast || (Contrast = {}));
//# sourceMappingURL=contrast.js.map